import { defineComponent as u, openBlock as o, createElementBlock as l, mergeProps as i, unref as e, renderSlot as V, createElementVNode as n, createCommentVNode as g } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const A = { key: 0 }, f = { key: 1 }, k = { key: 2 }, M = { key: 3 }, Z = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconNumberOne"
}, L = /* @__PURE__ */ u({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const a = s, { bind: d, weight: r } = m(a);
    return (p, t) => (o(), l("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      V(p.$slots, "default"),
      e(r) === "bold" ? (o(), l("g", A, t[0] || (t[0] = [
        n("path", { d: "M148,48V208a12,12,0,0,1-24,0V69.19l-21.83,13.1A12,12,0,0,1,89.83,61.71l40-24A12,12,0,0,1,148,48Z" }, null, -1)
      ]))) : e(r) === "duotone" ? (o(), l("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M216,40V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V40A16,16,0,0,1,56,24H200A16,16,0,0,1,216,40Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M144,48V208a8,8,0,0,1-16,0V62.13L100.12,78.86a8,8,0,1,1-8.24-13.72l40-24A8,8,0,0,1,144,48Z" }, null, -1)
      ]))) : e(r) === "fill" ? (o(), l("g", k, t[2] || (t[2] = [
        n("path", { d: "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM144,184a8,8,0,0,1-16,0V84.94L107.58,95.16a8,8,0,1,1-7.16-14.32l32-16A8,8,0,0,1,144,72Z" }, null, -1)
      ]))) : e(r) === "light" ? (o(), l("g", M, t[3] || (t[3] = [
        n("path", { d: "M142,48V208a6,6,0,0,1-12,0V58.6L99.09,77.14a6,6,0,0,1-6.18-10.29l40-24A6,6,0,0,1,142,48Z" }, null, -1)
      ]))) : e(r) === "regular" ? (o(), l("g", Z, t[4] || (t[4] = [
        n("path", { d: "M144,48V208a8,8,0,0,1-16,0V62.13L100.12,78.86a8,8,0,1,1-8.24-13.72l40-24A8,8,0,0,1,144,48Z" }, null, -1)
      ]))) : e(r) === "thin" ? (o(), l("g", h, t[5] || (t[5] = [
        n("path", { d: "M140,48V208a4,4,0,0,1-8,0V55.06L98.06,75.43a4,4,0,0,1-4.12-6.86l40-24A4,4,0,0,1,140,48Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  L as default
};
